import humps from 'humps'

import {
  getExposedCredentials,
  destroyCredentials,
} from '../localStorage/authentication'
import { isProxy } from 'config'

const requestAuthMiddleware = request => {
  if (isProxy()) {
    request.headers['Accept-Version'] = 'v1'
    return request
  }

  const { accessToken } = getExposedCredentials()

  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`
    request.headers['Accept-Version'] = 'v1'
  }

  return request
}

const requestScenarioSelectorMiddleware = request => {
  const key = `SCENARIO_SELECTOR(${request.baseURL}${request.url})`
  let scenario = sessionStorage.getItem(key)

  if (!scenario) {
    sessionStorage.setItem(key, 'success')
    scenario = 'success'
  }

  request.headers['Accept-Scenario'] = scenario

  return request
}

const requestSerializationMiddleware = request => {
  if (request.data && !(request.data instanceof FormData)) {
    const dataSerialized = humps.decamelizeKeys(request.data)
    request.data = dataSerialized
  }

  return request
}

const responseMiddlewareSuccess = response => {
  const dataSerialized = humps.camelizeKeys(response.data)
  response.data = dataSerialized
  return response
}

const responseMiddlewareError = error => {
  if (isProxy()) {
    return Promise.reject(error)
  }
  if (error.response && error.response.status === 401) {
    destroyCredentials()
    window.location.href = '/entrar'
  }
  if (error.name === 'LocalStorageError') {
    window.location.href = '/entrar'
  }
  return Promise.reject(error)
}

export {
  requestAuthMiddleware,
  requestScenarioSelectorMiddleware,
  requestSerializationMiddleware,
  responseMiddlewareSuccess,
  responseMiddlewareError,
}
